import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faSort } from '@fortawesome/free-solid-svg-icons';

export type SortDir = 'asc' | 'desc';

interface SortHeaderProps {
  label: string;
  /** Whether this column is the active sort. */
  active: boolean;
  dir: SortDir;
  onSort: () => void;
  className?: string;
}

/** Sortable table header cell — shared by the workflow/dashboard library tables. */
const SortHeader: React.FC<SortHeaderProps> = ({ label, active, dir, onSort, className = '' }) => (
  <th
    className={`px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider cursor-pointer select-none hover:text-neutral-700 transition-colors ${className}`}
    onClick={onSort}
  >
    <span className="inline-flex items-center gap-1.5">
      {label}
      <FontAwesomeIcon
        icon={active ? (dir === 'asc' ? faSortUp : faSortDown) : faSort}
        className={`w-3 h-3 ${active ? 'text-primary-500' : 'text-neutral-300'}`}
      />
    </span>
  </th>
);

export default SortHeader;
